import api from '@/api'

const { $student, $pricing, $academic, $core } = api;

export const { $types } = $pricing;
export const { $careers } = $academic;
export const { $alumnos, $studentByIdentification, $studentsData } = $student; 
export const { $users } = $core;
